export default __webpack_public_path__ + "static/uiuxcase1-6880a5a3564b38cb7d02a35f0490324e.png";